<div class="main">
  <image-cropper
    (imageCropped)="onImageCropped($event)"
    (imageLoaded)="onImageLoaded($event)"
    [imageBase64]="cleanImageBase64"
    [aspectRatio]="aspectRadio"
    [maintainAspectRatio]="maintainAspectRatio"
  ></image-cropper>
</div>

<ion-footer class="custom-footer">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" (click)="cancel()">Cancelar</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button expand="block" data-testid="cropper-confirm-btn" (click)="confirm()">Confirmar</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
